"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function flattenNamespace(obj) {
    const flattened = {};
    for (const namespace in obj) {
        for (const featureName in obj[namespace]) {
            flattened[`${namespace}/${featureName}`] = obj[namespace][featureName];
        }
    }
    return flattened;
}
exports.default = flattenNamespace;
//# sourceMappingURL=flatten-namespace.js.map